import ProfessionalNavbar from "./ProfessionalNavbar";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";

export default function MainLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-white w-full overflow-x-hidden">
      <ProfessionalNavbar />
      <main id="main-content" className="flex-1 w-full p-0 m-0">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}